import { encore, resto, ssoService } from '@saucelabs/sl-util-axios';

export const getSaml = ({ id }) => (
  resto.get(`/rest/v1/${id}/saml`)
);

export const updateSaml = ({ id, payload }) => (
  encore.post(`/api/user/${id}/saml`, payload)
);

export const deleteSaml = ({ id }) => (
  encore.post(`/api/user/${id}/saml/delete`)
);

// All api calls below belong to Global SSO managed via sso-service.
export const getConfig = ({ orgUuid }) => (
  ssoService.get(`/config/${orgUuid}`)
);

export const updateConfig = ({ orgUuid, payload }) => (
  ssoService.patch(`/config/${orgUuid}`, payload)
);

export const deleteConfig = ({ orgUuid }) => (
  ssoService.delete(`/config/${orgUuid}`)
);

export const checkAvailable = ({ orgUuid }) => (
  ssoService.get(`/config/${orgUuid}/available`)
);
